import React from "react"
import styled from "styled-components"
import { Contact } from "../res/styles/TextStyles"

const Info = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px;
`

const Icon = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 10px;
`

const Link = styled.a`
    text-decoration: none;
`

function ContactInfo(props) {
    return (
        <Link href={props.link} target="_blank">
            <Info>
                <Icon src={props.img} />
                <Contact>{props.text}</Contact>
            </Info>
        </Link>
    )
}

export default ContactInfo
